webpackJsonp([12],{

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("nSbf");


/***/ }),

/***/ "gpn5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nSbf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icon64_scss__ = __webpack_require__("gpn5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icon64_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__icon64_scss__);



/***/ })

},[2]);


// WEBPACK FOOTER //
// js/icon64.js